import { normalizeReferenceUnwrappedArgs, ReferenceUnwrapped, } from "./ReferenceUnwrapped.js";
export function unwrapRef(...args) {
    return new ReferenceUnwrapped(normalizeReferenceUnwrappedArgs(args));
}
